/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_UnavailableInputs */

const en_us2_transcribe_unavailable = /** @type {(inputs: Transcribe_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dictation isn't available right now. Try again, or type your message.`)
};

const pt_br2_transcribe_unavailable = /** @type {(inputs: Transcribe_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ditado não está disponível agora. Tente de novo ou digite a mensagem.`)
};

const es_419_transcribe_unavailable = /** @type {(inputs: Transcribe_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El dictado no está disponible ahora. Intenta de nuevo o escribe tu mensaje.`)
};

const pt_pt2_transcribe_unavailable = /** @type {(inputs: Transcribe_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ditado não está disponível agora. Tenta outra vez ou escreve a mensagem.`)
};

const fr_fr2_transcribe_unavailable = /** @type {(inputs: Transcribe_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dictée n'est pas disponible pour le moment. Réessaie, ou écris ton message.`)
};

const de_de2_transcribe_unavailable = /** @type {(inputs: Transcribe_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diktieren ist gerade nicht verfügbar. Versuch es noch mal oder tippe deine Nachricht.`)
};

const it_it2_transcribe_unavailable = /** @type {(inputs: Transcribe_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dettatura non è disponibile al momento. Riprova o scrivi il messaggio.`)
};

/**
* | output |
* | --- |
* | "Dictation isn't available right now. Try again, or type your message." |
*
* @param {Transcribe_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const transcribe_unavailable = /** @type {((inputs?: Transcribe_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_transcribe_unavailable(inputs)
	if (locale === "es-419") return es_419_transcribe_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_transcribe_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_transcribe_unavailable(inputs)
	if (locale === "de-DE") return de_de2_transcribe_unavailable(inputs)
	if (locale === "it-IT") return it_it2_transcribe_unavailable(inputs)
	return en_us2_transcribe_unavailable(inputs)
});
export { transcribe_unavailable as "transcribe.unavailable" }